import 'scripts/form_submit_dispLoading'
import 'scripts/core/carousel_controll'
import { pathArr, APP_NAME, VIEW_NAME } from 'scripts/utils/router'
import ItemDetail from 'scripts/core/ItemDetail.svelte';

let app = undefined

if (APP_NAME === 'shop') {
    app = new ItemDetail({
        target: document.querySelector('.sv-component')!,
    });
}


export default app;